import React from "react";

import { SelectInput, SelectInputProps } from "react-admin";

const InvoiceIntervalSelectInput = (props: SelectInputProps) => {
  return (
    <SelectInput
      choices={[
        { id: "Monthly", name: "monatlich" },
        { id: "Quarterly", name: "quartalsweise" },
        { id: "Semiannual", name: "halbjährlich" },
        { id: "Yearly", name: "jährlich" },
        { id: "None", name: "nicht abgerechnet" },
      ]}
      {...props}
    />
  );
};
export default InvoiceIntervalSelectInput;
